import {svgIconWrapper} from '../svg-icon-wrapper';

import SlackRegular from './slack-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SlackRegular {...props} />;
}

SvgComponent.iconName = 'slackRegular';

export const SlackRegularIcon = svgIconWrapper(SvgComponent);
